import Button from '@material-ui/core/Button'
import React from 'react'
import Grid from '@material-ui/core/Grid'
import { makeStyles } from '@material-ui/core/styles'
import { specialTheme, widthXS } from '../theme'

type ButtonProps = {
  children: any
  props?: any
  onClick: () => void
}

const useStyles = makeStyles((theme) => ({
  button: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontFamily: specialTheme.font.fontFSMe,
    color: specialTheme.colors.white,
    backgroundColor: specialTheme.colors.darkRed,
    '&:hover': {
      backgroundColor: specialTheme.colors.darkRed,
    },
    padding: '0 60px',
    [theme.breakpoints.down(widthXS)]: {
      width: '100%',
      margin: '0 15px 0 0',
    },
    textTransform: 'initial',
    fontSize: '1rem',
    borderRadius: 0,
    height: 46,
    minWidth: 210,
  },
  gridCenter: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },
}))

const ReportButton = ({ children, props, onClick }: ButtonProps) => {
  const classes = useStyles()
  return (
    <Grid item xs={12} sm={12} xl={12} className={classes.gridCenter}>
      <Button
        type="button"
        onClick={onClick}
        className={classes.button}
        {...props}
      >
        {children}
      </Button>
    </Grid>
  )
}

export default ReportButton
